let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dbZJz"), load("hFtKc")]).then(() => parcelRequire('2rynm'));